"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegionIDC = exports.IDCRegion = exports.VGeo = exports.RegionDisplayMap = exports.Region = void 0;
/**
 * ISO 639-1 Language Code
 *
 * lower case
 */
var Region;
(function (Region) {
    Region["jp"] = "jp";
    Region["th"] = "th";
    Region["my"] = "my";
    Region["id"] = "id";
    Region["ph"] = "ph";
    Region["vn"] = "vn";
    Region["us"] = "us";
    Region["gb"] = "gb";
    Region["sg"] = "sg";
})(Region = exports.Region || (exports.Region = {}));
exports.RegionDisplayMap = {
    [Region.jp]: '日本',
    [Region.th]: 'ไทย',
    [Region.my]: 'Malaysia',
    [Region.id]: 'Indonesia',
    [Region.vn]: 'Việt Nam',
    [Region.us]: 'US',
    [Region.gb]: 'UK',
    [Region.sg]: 'Singapore',
    [Region.ph]: 'Philippines',
};
var VGeo;
(function (VGeo) {
    VGeo["US"] = "US";
    VGeo["ROW"] = "ROW";
})(VGeo = exports.VGeo || (exports.VGeo = {}));
/**
 * @deprecated not compatible with TTP
 */
var IDCRegion;
(function (IDCRegion) {
    IDCRegion["VA"] = "va";
    IDCRegion["SG"] = "sg";
})(IDCRegion = exports.IDCRegion || (exports.IDCRegion = {}));
/**
 * @deprecated not compatible with TTP
 */
const getRegionIDC = (region) => {
    return [Region.jp, Region.us, Region.gb].includes(region) ? IDCRegion.VA : IDCRegion.SG;
};
exports.getRegionIDC = getRegionIDC;
